export default {
    url: '/list',
    template: '<review-list classifiers="vm.classifiers"></review-list>',
    resolve: {
        classifiers (ClassifierResource, CLASSIFIER_ENUM) {
            return ClassifierResource.query({
                'types[]': [
                    CLASSIFIER_ENUM.KEYS.DEPARTMENT,
                    CLASSIFIER_ENUM.KEYS.ROLE,
                    CLASSIFIER_ENUM.KEYS.LEVEL
                ]
            }).$promise;
        }
    },
    controller (classifiers) {
        this.classifiers = classifiers;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/review/list/index.js